/* 融资申请 */

import ajax from '../ajax';
import axios from 'axios';

export default {
  // 获取产品详情
  getLoanProductDetail (params) {
    return ajax.postForm(`loanform/base/loanBaseProduct/getLoanProductDetail.ht`, params);
  },
  // 提交申请下一步
  inputFinancingDemandInfo (params) {
    return ajax.postForm(`loanform/blitem/blLoanItemFrontApply/inputFinancingDemandInfo.ht`, params);
  },
  // 获取第二步列表数据
  getFrontVoucherInfoList (params) {
    return ajax.postForm(`loanform/blitem/blLoanAccountVoucherInfo/getFrontVoucherInfoList.ht`, params);
  },
  // 获取第二步买方公司名称数据
  addFrontVoucherInfoPage (params) {
    return ajax.postForm(`loanform/blitem/blLoanAccountVoucherInfo/addFrontVoucherInfoPage.ht`, params);
  },
  // 获取第二步添加一条数据
  saveFrontVoucherInfo (params) {
    return ajax.postForm(`loanform/blitem/blLoanAccountVoucherInfo/saveFrontVoucherInfo.ht`, params);
  },
  // 删除数据
  delVoucherInfo (params) {
    return ajax.postForm(`loanform/blitem/blLoanAccountVoucherInfo/delVoucherInfo.ht`, params);
  },
  // 绑定银行卡
  saveFrontBankAccount (params) {
    return ajax.postForm(`loanform/blitem/blLoanItemFrontApply/saveFrontBankAccount.ht`, params);
  },
  // 获取文件列表
  goItemFilesPage (params) {
    return ajax.postForm(`loanform/blitem/blLoanItemFiles/goItemFilesPage.ht`, params);
  },
  // 图片上传成功回调保存接口
  saveItemFiles (params) {
    return ajax.postForm(`loanform/blitem/blLoanItemFiles/saveItemFiles.ht`, params);
  },
  // 确认申请接口
  confirmApply (params) {
    return ajax.postForm(`loanform/blitem/blLoanItemFrontApply/confirmApply.ht`, params);
  },
  // 检查申请接口
  checkApply (params) {
    return ajax.postForm(`loanform/blitem/blLoanItemFrontApply/checkApply.ht`, params);
  },
  // 删除附件接口
  delItemFile (params) {
    return ajax.postForm(`/loanform/blitem/blLoanItemFiles/delItemFile.ht`, params);
  },
  // 选中凭证保存接口
  saveFrontVoucherInfoList (params) {
    return ajax.postForm(`loanform/blitem/blLoanAccountVoucherInfo/saveFrontVoucherInfoList.ht`, params);
  },
  // 根据产品id获取草稿项目
  getDraftApply (baseProductId, frontApplyId) {
    const params = {
      baseProductId,
      frontApplyId
    };
    return axios.get(
      `loanform/blitem/blLoanItemFrontApply/getDraftApply.ht`,
      {
        headers: {
          tokenId: localStorage.getItem('dl_tokenId_bl')
        },
        params
      }
    );
  },
  // 检查是否签订三方协议
  checkMainContractSign (buyerId, productId) {
    const params = {
      buyerId,
      productId
    };
    return axios.get(
      `/mobile/item/pdfSignatureController/checkMainContractSign.ht`,
      {
        headers: {
          tokenId: localStorage.getItem('dl_tokenId_bl')
        },
        params
      }
    );
  }
};



// WEBPACK FOOTER //
// ./src/api/applyloan/applyloan.js